module.exports = __webpack_public_path__ + "static/media/clover-mini-pos-device-any-business-small.9195d8a1.jpg";